module.exports = __webpack_public_path__ + "img/link-handbook-mobile_cn.a5fca35.jpg";